import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';

@Injectable({ providedIn: 'root' })
export class AssembleTransactionsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    createAssemble(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    getAssembleHistories(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<any[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/AssembleTransactions${v}`);
    }
}